import { getApiErrorStatus } from "../../lib/api/apiError";
import { fetchPaystackStatus, initPaystackPayment } from "./paymentsService";
import { mapPaystackInitialization, mapPaystackStatus } from "./paymentsMappers";
import { savePendingPaystack } from "./paystackReturn";

export const VERIFY_ATTEMPTS = 3;
export const VERIFY_DELAY_MS = 2000;

const wait = (ms) => new Promise((resolve) => setTimeout(resolve, ms));

export const pollPaystackStatus = async (reference, { attempts, delayMs }) => {
  for (let i = 0; i < attempts; i += 1) {
    let status;

    try {
      status = mapPaystackStatus(await fetchPaystackStatus(reference));
    } catch (err) {
      if (getApiErrorStatus(err) === 404) return { status: "UNKNOWN" };

      throw err;
    }

    if (status.status === "COMPLETED" || status.status === "FAILED") return status;

    await wait(delayMs);
  }

  return { status: "PENDING" };
};

export const startPaystackPayment = async ({ amount, email, description, context }) => {
  const init = mapPaystackInitialization(
    await initPaystackPayment({ amount, email, description })
  );

  if (!init) throw new Error("Could not start the payment. Please try again.");

  savePendingPaystack({ reference: init.reference, ...context });

  return init;
};

export const settlePaystackOrder = async ({ reference, trusted, place, reserve }) => {
  if (!reference) return { status: "missing-reference" };

  if (!trusted) {
    const status = await pollPaystackStatus(reference, {
      attempts: VERIFY_ATTEMPTS,
      delayMs: VERIFY_DELAY_MS,
    });

    if (status.status === "FAILED") return { status: "failed" };
  }

  const payload = { paymentReference: reference };
  const result = await place(payload);

  if (result.status !== "expired" || !reserve) return result;

  const reserved = await reserve();

  if (reserved.status !== "reserved") return result;

  return place(payload, { reservationOverride: reserved.reservation });
};
